import { ChevronDownIcon, ChevronUpIcon } from '@moia-dev/pace-icons'
import { Button } from '@moia-dev/pace-web'
import type { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

export const VehicleMissionCardExpanderButton = ({
  setIsExpanded,
  isExpanded,
  amountOfOutOfViewportWaypoints,
}: {
  setIsExpanded: Dispatch<SetStateAction<boolean>>
  isExpanded: boolean
  amountOfOutOfViewportWaypoints: number
}) => {
  const { t } = useTranslation()

  return (
    <div
      css={theme => ({
        display: 'flex',
        justifyContent: 'center',
        position: 'absolute',
        bottom: 36,
        zIndex: 100,
        width: '100%',
        backgroundColor: theme.semantic.ColorSurfaceDefault,
        height: 56,
      })}
    >
      <Button
        onClick={() => setIsExpanded(prevState => !prevState)}
        label={
          isExpanded
            ? t('adFleetMap_missionCard_expander_button_collapse_label')
            : amountOfOutOfViewportWaypoints > 1
              ? t('adFleetMap_missionCard_expander_button_expandPlural_label', {
                  numberOfWaypoints: amountOfOutOfViewportWaypoints,
                })
              : t(
                  'adFleetMap_missionCard_expander_button_expandSingular_label',
                  { numberOfWaypoints: amountOfOutOfViewportWaypoints },
                )
        }
        icon={isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
        variant="plain"
        size="compact"
        css={{
          zIndex: 100,
          height: 'fit-content',
        }}
      />
    </div>
  )
}
